// Centralized API configuration
export const API_CONFIG = {
  // Main API base URL — hosts chat, session, ingestion, and tenant/employee routes
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api-platform.niwt.com',

  // Connection Manager API (OAuth2 connection lifecycle) — Area 2
  CONNECTION_API_URL: process.env.REACT_APP_CONNECTION_API_URL || 'https://api-platform.niwt.com',
};
